import { inPropertyAudiences } from 'features/Announcements/constants'
import PropTypes from 'prop-types'
import { Link, useParams } from 'react-router-dom'

import styles from './AudienceCard.module.scss'

const AudienceCard = ({ type = 'inHouse' }) => {
  const audience = inPropertyAudiences[type]

  const { audience: activeAudience } = useParams()

  const isActive = type === activeAudience

  const Icon = audience?.icon
  const borderColor = audience?.accentColor
  const title = audience?.name
  const description = audience?.description

  return (
    <Link
      to={`/announcements/${type}`}
      className={isActive ? styles.activeCard : styles.card}
      style={{ borderColor }}
    >
      <div className={styles.iconHolder}>
        <Icon />
      </div>
      <div className={styles.contentHolder}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
      </div>
    </Link>
  )
}

AudienceCard.propTypes = {
  type: PropTypes.oneOf([
    'InHouse',
    'ArrivingToday',
    'ArrivingTomorrow',
    'DepartingToday',
    'DayBeforeCheckOut'
  ])
}

export default AudienceCard
